import { requestBids } from '../request.js';

import '../typedef.js';

export const LONG_FORM_THRESHOLD = '1.0';
export const RECIPE_THRESHOLD = '0.5';

/**
 * @param {EnrichedDynamicAdSlot} enrichedDynamicAdSlot
 */
const getHandleIntersect = (enrichedDynamicAdSlot) => {
  const handleIntersect = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestBids([enrichedDynamicAdSlot.gptSlot]);
        observer.unobserve(entry.target);
      }
    });
  };

  return handleIntersect;
};

/**
 *
 * @param {number} threshold
 * @param {EnrichedDynamicAdSlot} enrichedDynamicAdSlot
 */
export const createObserver = (threshold, enrichedDynamicAdSlot) => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold,
  };
  const slotElement = document.getElementById(enrichedDynamicAdSlot.id);
  const observer = new IntersectionObserver(
    getHandleIntersect(enrichedDynamicAdSlot),
    options,
  );

  observer.observe(slotElement);
};

/**
 * @param {string} type
 */
export const getThreshold = (type) => {
  switch (type) {
    case 'recipes':
      return RECIPE_THRESHOLD;
    default:
      return LONG_FORM_THRESHOLD;
  }
};

/**
 *
 * @param {string} type
 * @param {Array.<EnrichedDynamicAdSlot>} enrichedDynamicAdSlots
 */
export const adSlotsLazyLoad = (type, enrichedDynamicAdSlots) => {
  const threshold = getThreshold(type);

  enrichedDynamicAdSlots.forEach((slot) => {
    createObserver(threshold, slot);
  });
};
